import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n';
import App from './App';
import { initTheme } from './utils/theme';
import { installGlobalErrorHandlers } from './utils/errorReporter';

// Applique le thème clair/sombre AVANT le rendu → aucun flash de contenu.
initTheme();

// Remontée centralisée des erreurs JS non gérées (window.onerror / unhandledrejection).
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
